export default __webpack_public_path__ + "static/media/chave.6b899549.png";